<template>
	<div class="user">
		<el-row>
			<el-col :span="19" style="color:transparent">1
				<!-- <handlerbutton :handlerlist="handlerbtn" @buttonhandle="buttonhandle"></handlerbutton> -->
				</el-col>
			<el-col :span="5">
				<el-input v-model="searchkey" @keyup.enter.native="refreshgrid(true)" placeholder="可按账号\姓名\会员卡搜索" size="small" class="input-with-select"></el-input>
			</el-col>
		</el-row>
		<el-row style="height:10px;"></el-row>
		<el-row>
			<el-col :span="24">
				<tableui
					style="width:100%"
					v-loading="loading"
					ref="usertable"
					:tableData="userlist"
					:columns="columns"
					@gridhandle="gridhandle"
					:gridheight="gridheight"
					@gridsort="gridsort"
					@gridscroll="gridscroll"
					@checkboxchange="checkboxchange"
					@cellclick="cellclick"
				></tableui>
			</el-col>
		</el-row>
		<el-row>
			<el-col>共{{ count }}条数据</el-col>
		</el-row>
		<userinfo ref="userwin"></userinfo>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import handlerbutton from '@/components/handlerbutton/handler.vue';
import userinfo from '@/components/user/userinfo.vue';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui,
		handlerbutton,
		userinfo
	},
	props: {
		gridh: {
			type: String,
			defualt: ''
		},
		pagety: {
			type: String,
			defualt: 'grid'
		}
	},
	data() {
		return {
			handlerbtn: [],
			columns: [],
			userlist: [],
			count: 0,
			pagecount: 0,
			gridheight:'500px',
			userkey: '',
			userinfo: {},
			searchkey: '',
			sort: '', //列表排序
			loading: false,
			pagesize: 200,
			pageindex: 0,
			checkedrow: [],
			selectedall: false,
			mode: '用户管理',
			activeName: '用户管理',
			isloadscroll:false,
			pagetype:'grid'
		};
	},
	created() {
		if(this.gridh==undefined)
			this.gridheight=(window.innerHeight * 74) / 100+ 'px';
		else
			this.gridheight=this.gridh;
		if(this.pagety!=undefined)
			this.pagetype=this.pagety;
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/user.scss');
		});
		this.GetUserList(true, true);
		var that = this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
		
	},
	methods: {
		//获取用户列表，isinit--是否首次加载，isrefresh--是否刷新列表
		GetUserList(isinit, isrefresh) {
			var that = this;
			if (isinit) {
				this.$apipost.get.GetColumns({ tab: this.activeName, checkfield: 1, parentid: '13', mode: this.mode }).then(res => {
					that.columns = res;
					if(that.pagetype=='select')
						that.columns.splice(that.columns.length-1,1);
					
					that.refreshgrid(isrefresh);
				});
			} else {
				that.refreshgrid(isrefresh);
			}
		},
		//获取操作按钮权限
		// async GetHanlderBtn() {
		// 	var that = this;
		// 	this.$apipost.get.GetUserPermession({ type: '3', parentid: '13', mode: this.mode }).then(res => {
		// 		that.handlerbtn = res.linklist;
		// 	});
		// },
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 84) {
					that.GetUserList(false, false);
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				//刷新
				that.pageindex = 0;
				this.selectedall = false;
			} else {
				//加载下一页
				if (that.pagecount - 1 > that.pageindex) {
					that.pageindex = that.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				that.loading = true;
				var search = new Object();
				search.searchkey = that.searchkey;
				this.$apipost.get.GetUserlist({ pageindex: this.pageindex, pagesize: this.pagesize, search: JSON.stringify(search), sort: this.sort }).then(res => {
					that.loading = false;
					if(isload&&!that.isloadscroll){
						that.gridscroll();
					}
					if(isrefresh){
						that.userlist=[];
					}
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.userlist = that.userlist.concat(JSON.parse(JSON.stringify(res.data)));
						} else {
							that.userlist = JSON.parse(JSON.stringify(res.data));
						}
					}
					that.pagecount = res.pagecount;
					that.count = res.count;
				});
			}
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.GetUserList(false, true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			// if (e.event == 'adduser') {
			// 	this.adduser();
			// }
			if (e.event == 'moveuser') {
				this.moveuser();
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			if (e.event == 'deluser') {
				this.deluser(e);
			}
			if (e.event == 'edituser') {
				this.edituser(e);
			}
		},
		// //新增用户
		// adduser() {
		// 	this.userkey = '';
		// 	this.userinfo = {};
		// 	this.showuserwin = true;
		// 	if (this.$refs.userwin != undefined) {
		// 		this.$refs.userwin.init({ userid: this.userkey, userinfo: this.userinfo });
		// 	}
		// },
		//修改用户信息
		edituser(e) {
			//打开窗口
			this.userkey = this.userlist[e.index].id;
			this.userinfo = this.userlist[e.index];
			if (this.$refs.userwin != undefined) {
				this.$refs.userwin.init({ userid: this.userkey, userinfo: this.userinfo });
			}
		},
		//删除用户信息
		deluser(e) {
			//this.$message("第"+e.index+"行");
			if (this.userlist[e.index].id == localStorage.getItem('userid')) {
				this.$tool.message('当前登录账号不允许删除', 0);
			} else {
				var that = this;
				this.$confirm('删除将导致用户的所有订单、账户余额全部清零，确定要删除此用户吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						this.$apipost.post.DelUser({ userid: this.userlist[e.index].id }).then(res => {
							if (res.state == '1') {
								this.$tool.message('删除成功', 1);
								that.GetUserList(false, true);
							} else {
								this.$tool.message(res.message, 0);
							}
						});
					})
					.catch(() => {});
			}
		},
		//列单击事件
		cellclick(e) {
			if (e.event == 'openurl') {
				if (e.column.field == 'vipaccount') {
					Utils.$emit('handleRermove', 98);
					var value = e.row[e.column.field];
					setTimeout(function() {
						Utils.$emit('go', { l_url: '/cw/vipbill', l_id: 98, urlparam: { vipaccount: value } });
					}, 200);
				}
			}
		},
		GetSearchObj() {
			var search = new Object();
			if (this.searchkey != '') search.searchkey = this.searchkey;
			return JSON.stringify(search);
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		GetCheckedOrder(isempty) {
			var userid = '';
			var search = {
				id: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					userid += e.id + ',';
				});
				if (userid != '') {
					userid = userid.substring(0, userid.length - 1);
					search.id = userid; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选用户', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		ResetFilterInfo() {
			this.searchkey = '';
			this.refreshgrid(true);
		}
	}
};
</script>
